var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCounterTop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2494_3994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181 120C214.137 120 241 93.1371 241 60C241 26.8629 214.137 0 181 0C147.863 0 121 26.8629 121 60C121 93.1371 147.863 120 181 120Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 151C367.709 151 361 157.709 361 166V182.644C331.677 188.641 308.495 211.672 302.516 241H449.484C443.506 211.672 420.323 188.641 391 182.644V166C391 157.709 384.291 151 376 151Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 211V241H271V211C271 161.371 230.629 120 181 120C131.371 120 91 161.371 91 211Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 436H391V346H121V436ZM316 376C324.284 376 331 382.714 331 391C331 399.284 324.284 406 316 406C307.716 406 301 399.284 301 391C301 382.714 307.716 376 316 376ZM256 376C264.284 376 271 382.714 271 391C271 399.284 264.284 406 256 406C247.716 406 241 399.284 241 391C241 382.714 247.716 376 256 376ZM196 376C204.284 376 211 382.714 211 391C211 399.284 204.284 406 196 406C187.716 406 181 399.284 181 391C181 382.714 187.716 376 196 376Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 271H15C6.709 271 0 277.709 0 286C0 294.291 6.709 301 15 301H30V497C30 505.291 36.709 512 45 512H467C475.291 512 482 505.291 482 497V301H497C505.291 301 512 294.291 512 286C512 277.709 505.291 271 497 271ZM421 451C421 459.291 414.291 466 406 466H106C97.709 466 91 459.291 91 451V331C91 322.709 97.709 316 106 316H406C414.291 316 421 322.709 421 331V451Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2494_3994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterTop);
export default __webpack_public_path__ + "static/media/counterTop.ec435a4b1af690ac888eae132ce1d020.svg";
export { ForwardRef as ReactComponent };